import { Translation } from '@ps/web-shared-components';
import {
  mustContainOnlyLatinAndSpanishCharacters,
  noWhiteStartOrEnd,
  required
} from '@ps/web-shared-validators';
import React, { useMemo } from 'react';
import { useField } from 'react-final-form';
import { useIntl } from 'react-intl';

import { Country } from '@swf/core/enums';

import InfoPrompt from '../../../../../InfoPrompt/InfoPrompt';
import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTCLI_Optional,
  TXTCLI_Second_Last_Name,
  TXTWCL_Please_enter_your_second_last__ELL
} from './SecondFamilyName.messages.json';
import styles from './SecondFamilyName.scss';

const fieldName = 'secondLastName';
const maxLength = 50;

const SecondFamilyName = () => {
  const { formatMessage } = useIntl();

  const {
    input: { value }
  } = useField(fieldName, { subscription: { value: true } });

  const {
    input: { value: citizenship }
  } = useField('citizenship', { subscription: { value: true } });

  const isSpanishCitizen = citizenship === Country.Spain;

  const validators = useMemo(() => {
    const baseValidators = [mustContainOnlyLatinAndSpanishCharacters(true), noWhiteStartOrEnd];

    if (isSpanishCitizen) {
      baseValidators.push(required());
    }
    return baseValidators;
  }, [isSpanishCitizen]);

  return (
    <TextInput
      id={fieldName}
      value={value}
      placeholder={
        isSpanishCitizen ? formatMessage(TXTCLI_Second_Last_Name) : formatMessage(TXTCLI_Optional)
      }
      labelClassName={styles.labelContent}
      label={TXTCLI_Second_Last_Name}
      labelContent={
        <InfoPrompt title={{ translation: TXTCLI_Second_Last_Name }}>
          <div className={styles.infoPrompt}>
            <Translation {...TXTWCL_Please_enter_your_second_last__ELL} tagName="span" />
          </div>
        </InfoPrompt>
      }
      maxLength={maxLength}
      checkDisabled
      validators={validators}
    />
  );
};

export default SecondFamilyName;
